import { render } from "./QuestionGroupForm.vue?vue&type=template&id=5fe5979a&scoped=true"
import script from "./QuestionGroupForm.vue?vue&type=script&lang=js"
export * from "./QuestionGroupForm.vue?vue&type=script&lang=js"

import "./QuestionGroupForm.vue?vue&type=style&index=0&id=5fe5979a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe5979a"]])

export default __exports__